/**
 * <ObjectArray 
 *		// please describe props here
 *	/>
 *
 * This is...
 *
 * @parent anybody
 * @children 
 * @stateful
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
import Form from 'components/Form'; 
import cloneDeep from 'lodash/cloneDeep';
import './ObjectArray.scss';

class ObjectArray extends React.Component {
  constructor(props) {
    super(props);
    
    this.onChange = this.onChange.bind(this);
    this.addItem = this.addItem.bind(this);
    this.removeItem = this.removeItem.bind(this);
  }

  componentWillMount() {

  }

  addItem(index) {
    return ()=>{
      let returnValue = cloneDeep(this.props.value || []);
      returnValue.splice(index + 1, 0, {}); 
      this.props.onChange(returnValue);
    }
  }
  
  removeItem(index) {
    return ()=>{
      let returnValue = cloneDeep(this.props.value || []);
      returnValue.splice(index, 1); 
      this.props.onChange(returnValue);
    }
  }
    
  onChange(index) {
    return (itemValue)=>{
      let returnValue = cloneDeep(this.props.value);
      returnValue[index] = itemValue;
      this.props.onChange(returnValue);
    }
  }

  render() {
    const {
      objectSchema = [],
      value = [],
    } = this.props;

    return (
      <div className='ObjectArray'>
        
          <ul className={classnames('ObjectArray--basket', { 'has-padding-bottom': value.length == 0 })}>
          {value.length > 0 && value.map((itemValue, index)=>{
            return (
              <li key={index}>
                <div className='ObjectArray--item'>
                  <a className='delete-btn' onClick={this.removeItem(index)}>
                    <i className='fa icon-cancel' />
                  </a>
                  <Form
                    formStyle='outline'
                    onChange={this.onChange(index)}
                    formData={itemValue}
                    schema={objectSchema}
                  />
                </div>
                <div className='ObjectArray--addArrayItem'>
                  <i 
                    className='addButton fa icon-plus' 
                    onClick={this.addItem(index)}>
                  </i>
                </div>
              </li>
            );
          })}
          {value.length == 0 &&
            <li>
              <div className='ObjectArray--addArrayItem'>
                <i 
                  className='addButton fa icon-plus' 
                  onClick={this.addItem(0)}>
                </i>
              </div>
            </li>
          }
        </ul>

      </div>
    )
  }
}

export default ObjectArray;



// WEBPACK FOOTER //
// ./src/components/Form/Fields/ObjectArray/index.js